import axios from "axios";
import { GetLinksRoleByCountry } from "./GetLinksRoleByCountryAction";

const apiUrl = `${process.env.REACT_APP_BASE_API_URL}/api/Menu/AssignLinkRole`;
const ApiKey = process.env.REACT_APP_BASE_API_KEY;

export const AssignLinkRole = (idRole, idLink) => async (dispatch) => {
  try {
    const postData = {
      idRole: Number(idRole),
      idLink: Number(idLink),
    };

    const axiosConfig = {
      headers: {
        ApiKey: ApiKey,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(apiUrl, postData, axiosConfig);
    await dispatch(GetLinksRoleByCountry());

    return { success: true, message: response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data || error.message,
    };
  }
};
